import { RestLink } from 'apollo-link-rest';
import type { LangISOCode } from '@olxpwa-lib/i18n/types';

type RestLinkProps = {
  baseUrl: string;
  langISOCode: LangISOCode;
};

export const createRestLink = ({ baseUrl, langISOCode }: RestLinkProps) =>
  new RestLink({
    endpoints: {
      v1: {
        uri: `${baseUrl}/api/v1`,
        responseTransformer: async (response, typeName) =>
          response.json().then((data: any) => {
            if (typeName === 'AtlasUser') {
              return data.data;
            }
          }),
      },
    },
    headers: {
      'Accept-Language': langISOCode,
    },
    uri: baseUrl,
  });

export const useRestLink = ({ baseUrl, langISOCode }: RestLinkProps) =>
  createRestLink({ baseUrl, langISOCode });
